import e from "react";
import { componentName as r } from "../../../utils/bem/index.js";
function t(e, r, t) {
  return r in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function n(n) {
  var o,
    l = n.children,
    a = n.color,
    c = void 0 === a ? "black" : a,
    i = n.size,
    u = void 0 === i ? "default" : i,
    f = function (e, r) {
      if (null == e) return {};
      var t,
        n,
        o = function (e, r) {
          if (null == e) return {};
          var t,
            n,
            o = {},
            l = Object.keys(e);
          for (n = 0; n < l.length; n++) t = l[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
          return o;
        }(e, r);
      if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(e);
        for (n = 0; n < l.length; n++) t = l[n], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
      }
      return o;
    }(n, ["children", "color", "size"]);
  return f.className = r("tag", f.className, (t(o = {}, "color-".concat(c), c), t(o, "size-".concat(u), u), o)), e.createElement("span", f, l);
}
n.displayName = n;
export { n as Tag };